import { render, staticRenderFns } from "./save-account-dialog.component.vue?vue&type=template&id=16a1206a"
import script from "./save-account-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./save-account-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16a1206a')) {
      api.createRecord('16a1206a', component.options)
    } else {
      api.reload('16a1206a', component.options)
    }
    module.hot.accept("./save-account-dialog.component.vue?vue&type=template&id=16a1206a", function () {
      api.rerender('16a1206a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin-panel/account-setup/save-account-dialog/save-account-dialog.component.vue"
export default component.exports